var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'no-bar': _vm.noBar },attrs:{"id":"app"}},[(!_vm.noBar)?_c('navbar'):_vm._e(),_c('main',[_c('router-view')],1),_c('footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }